// Global
import { useSitecore } from '@sitecore-content-sdk/nextjs';
import { useEffect, useState } from 'react';

const useIsEditing = () => {
  const context = useSitecore();
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (context?.page?.mode.isEditing) {
      setIsEditing(true);
    }
  }, [context?.page?.mode.isEditing]);

  return isEditing;
};

export default useIsEditing;
